import type { ComponentPropsWithRef, ReactNode } from "react";

import { cx } from "@/lib/cx";

import styles from "./Badge.module.css";

export type Tone = "neutral" | "accent" | "pass" | "fail" | "warn" | "skip";

export interface BadgeProps extends ComponentPropsWithRef<"span"> {
  tone?: Tone;
  /** Leading icon. Decorative: the text carries the meaning, so status is never colour alone (WCAG 1.4.1). */
  icon?: ReactNode;
}

export function Badge({ tone = "neutral", icon, className, children, ...props }: BadgeProps) {
  return (
    <span className={cx(styles.badge, styles[tone], className)} {...props}>
      {icon !== undefined && (
        <span className={styles.icon} aria-hidden="true">
          {icon}
        </span>
      )}
      {children}
    </span>
  );
}
